// @flow
import type { Saga } from "redux-saga";

import { all, fork } from "redux-saga/effects";
import Api from "../../utils/api";
import * as userSagas from "./user";
import * as notificationsSaga from './notifications';
import leaguesDraftSagaUtil from './leagueDraft';
import checksumsSagaUtil from './checksums';
import teamDraftSagaUtil from './teamDraft';
import playersSagaUtil from './players';
import roundsSagaUtil from './rounds';
import squadsSagaUtil from './squads';
import venuesSagaUtil from './venues';

const roundsSagas = roundsSagaUtil(Api);
const squadsSagas = squadsSagaUtil(Api);
const venuesSagas = venuesSagaUtil(Api);
const leaguesDraftSagas = leaguesDraftSagaUtil(Api);
const teamDraftSagas = teamDraftSagaUtil(Api);
const checksumsSagas = checksumsSagaUtil(Api);
const playersSagas = playersSagaUtil(Api);

export default function* rootSaga(): Saga<void> {
	yield all([
		...Object.values(userSagas),
		...Object.values(notificationsSaga),
		leaguesDraftSagas.watch,
		teamDraftSagas.watch,
		roundsSagas.watch,
		playersSagas.watch,
		squadsSagas.watch,
		venuesSagas.watch,
		checksumsSagas.watch,
	].map(saga => fork(saga)));
}


// WEBPACK FOOTER //
// ./src/modules/sagas/index.js